import { Injectable, inject } from '@angular/core'
import { Filter, Interval, RestClientPaged } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { FacilitySchedule } from './facility-schedule'
import { environment } from '../../../../environments/environment'

export class FacilityScheduleFilter {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly FACILITY_IDS_KEY = 'facilityIds'

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static facilityId(facilityId: string): Filter {
    return new Filter(this.FACILITY_IDS_KEY, facilityId)
  }

  public static interval(interval: Interval): Filter {
    return new Filter('interval', interval.toInstantString())
  }
}

@Injectable({
  providedIn: 'root',
})
export class FacilityScheduleService extends RestClientPaged<FacilitySchedule, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/facilities/work-schedules', http, {
      idField: 'id',
    })
  }
}
